import { render, staticRenderFns } from "./loseWeight.vue?vue&type=template&id=3d70599b&scoped=true"
import script from "./loseWeight.vue?vue&type=script&lang=js"
export * from "./loseWeight.vue?vue&type=script&lang=js"
import style0 from "./loseWeight.vue?vue&type=style&index=0&id=3d70599b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d70599b",
  null
  
)

export default component.exports